// 按钮对应的权限
var BUTTON_RIGHTS = {
}

// 角色对应的权限
var ROLE_RIGHTS = {
  /**
   * 登录APP（注：下列权限都包含app_login权限，可不必单独赋app_login权限,只有不包含其他权限时才需要赋app_login权限，例:BOSS端）
   */
  app_login: {
    name: 'app_login',
    title: '登录APP',
    buttonRights: []
  },
  /**
   * 系统管理
   */
  Administration: {
    name: 'administration',
    title: '系统管理',
    buttonRights: []
  },
  /**
   * 系统管理
   */
  administration: {
    name: 'administration',
    title: '系统管理',
    buttonRights: []
  },
  /**
   * 组织机构管理
   */
  org_managment: {
    name: 'org_managment',
    title: '组织机构管理',
    buttonRights: []
  },
}

export { ROLE_RIGHTS, BUTTON_RIGHTS }
